/* eslint camelcase: 0 */
import { toHospitalProps } from './hospital'
import { toLogProps } from './log'
import { Doctor } from '@/infrastructure/network/Monitaro/schema/models'
import { IDoctorProps, EmptyDoctorPropsFactory } from '@/entities/Doctor'

export const toDoctorProps = (props: Doctor | null | undefined): IDoctorProps => {
  if (!props) {
    return EmptyDoctorPropsFactory()
  }

  const {
    id,
    hospitals,
    division,
    occupation,
    role,
    name,
    username,
    login,
    fcm_token,
    uuid,
    fullname,
    kana,
    organization,
    properties,
    flags,
    activation,
    log,
    invited_at,
    activate_at,
    created_at,
    updated_at,
    visit_mode,
    available_dates
  } = props

  return EmptyDoctorPropsFactory({
    id,
    hospitals: hospitals?.map(toHospitalProps),
    division,
    occupation,
    role,
    name,
    username,
    login,
    fcmToken: fcm_token,
    uuid,
    fullname,
    kana,
    organization,
    properties,
    flags,
    activation,
    log: toLogProps(log),
    invitedAt: invited_at,
    activateAt: activate_at,
    createdAt: created_at,
    updatedAt: updated_at,
    visitMode: visit_mode,
    availableDates: available_dates
  })
}
